export const COOKIES_NAME_CONFIG = {
  ACCESS_TOKEN: "cashless_crm_access_token",
  REFRESH_TOKEN: "cashless_crm_refresh_token",
  USER_DATA: "cashless_crm_user_data",
  TENANT_CONTEXT: "cashless_crm_tenant_context",
  SESSION_ID: "cashless_crm_session_id", // Redis session id cookie name
  XSRF_TOKEN: "cashless_crm_xsrf_token",
};
